module.exports = __webpack_public_path__ + "img/10_65.e3edf4ee.png";